module.exports = __webpack_public_path__ + "static/img/coupon_card.72f4e5e1.png";